import { formatCurrency } from "../../utils";
import { useAppSelector, useTranslation } from "../../hooks";
import { ModalProps } from "./Modal";
import Commander from "../../commander";
import Message from "./Message";

export const FR_STORAGE_KEY = "elysium-free-rounds-declined";

const FreeRounds: React.FC<ModalProps> = ({ shown }) => {
  const currency = useAppSelector((state) => state.details.currency);
  const { amount, stake, seen } = useAppSelector((state) => {
    return { ...state.freeRounds };
  });

  const acceptHandler = () => Commander.activateFreeRounds(amount, stake);
  const title = useTranslation("congratulations");
  const message = useTranslation(
    "freeroundsstart",
    amount.toString(),
    formatCurrency(stake, currency)
  );

  return (
    <Message
      shown={shown && !seen}
      icon="Info"
      title={title}
      message={message}
      onClose={acceptHandler}
    />
  );
};

export default FreeRounds;
